import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, getIDFromUrl, loadEtag, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { RAW_SCHEMA_QUERY_KEY } from './useRawSchema';

type PatchRawSchemaVariables = {
  content: unknown;
  etag: string | undefined;
};

export const usePatchRawSchema = (schemaUrl: Url | undefined) => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: ['patch-raw-schema', schemaUrl],
    mutationFn: ({ content, etag }: PatchRawSchemaVariables) =>
      api
        .fullRequest(
          endpoints.schemas.patchRaw(getIDFromUrl(schemaUrl!), { content }),
          { additionalHeaders: { 'If-Match': etag } }
        )
        .then(loadEtag),
    onSuccess: () => {
      queryClient.removeQueries(['poll-schema-etag', schemaUrl]);
      queryClient.invalidateQueries([RAW_SCHEMA_QUERY_KEY, schemaUrl]);
      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.schemaUpdated',
        }),
      });
    },
    onError: () => {
      queryClient.invalidateQueries(['poll-schema-etag', schemaUrl]);
      notify.error({
        title: intl.formatMessage({
          id: 'components.requestsDetail.schemaError',
        }),
      });
    },
  });
};
